import React from 'react';
import { Tray } from '@phosphor-icons/react';

// Consistent empty state: icon, title, optional hint + action.
export const EmptyState = ({ title, hint, icon: Icon = Tray, action, compact = false, testid = 'empty-state' }) => (
  <div className={`flex flex-col items-center justify-center text-center ${compact ? 'py-8' : 'py-14'} px-6`} data-testid={testid}>
    <div className={`${compact ? 'w-11 h-11' : 'w-14 h-14'} rounded-2xl bg-[#E8F5F3] text-[#00a69c] grid place-items-center mb-3`}>
      <Icon size={compact ? 20 : 26} weight="duotone" />
    </div>
    <p className="font-semibold text-[#052A23]" style={{ fontFamily: 'Outfit' }}>{title}</p>
    {hint && <p className="text-sm text-[#6D8E87] mt-1 max-w-md">{hint}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
